import React from "react";
import { Table,} from "react-bootstrap";
import { Pagination } from "antd";
import Loading from "../../../components/loading";
import NoData from "../../components/noData";
import moment from "moment";

const TransactionDetails = ({ isLoading, jobData, page, take, setPage, setTake, getDetails }: any) => {
  return (
    <div>
      {isLoading ? (
        <Loading />
      ) : jobData?.transactions?.data?.length ? (
        <>
          <Table bordered hover>
            <thead>
              <tr style={{ backgroundColor: "#08493e", color: "#fff" }}>
                <th className="table-th">Transaction Id</th>
                <th className="table-th">Card No.</th>
                <th className="table-th">Type</th>
                <th className="table-th">Payment Method</th>
                <th className="table-th">Amount</th>
                <th className="table-th">Ticket No.</th>
                <th className="table-th">Date</th>
              </tr>
            </thead>
            <tbody>
              {jobData?.transactions?.data?.map((activity: any, index: number) => (
                <tr key={index}>
                  <td>{activity?.transactionId}</td>
                  <td>{activity?.cardNo}</td>
                  <td>{activity?.type}</td>
                  <td>{activity?.paymentMethod}</td>
                  <td>{activity?.amount}</td>
                  <td>{activity?.ticketNo ?? "-"}</td>
                  <td>{moment(activity?.createdAt).format("DD-MM-YYYY")}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          <div style={{ textAlign: "right", marginTop: 16 }}>
            <Pagination
              current={page || 1}
              pageSize={take || 10}
              total={jobData?.transactions?.meta?.totalItems}
              showSizeChanger
              showTotal={(tot: any) => `Total ${tot} Transactions`}
              onChange={(page: any, pageSize: any) => {
                setPage(page);
                setTake(pageSize);
                getDetails(page, pageSize);
              }}
            />
          </div>
        </>
      ) : (
        <NoData />
      )}
    </div>
  );
};

export default TransactionDetails;
